import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { OfferingDetailsDayPass } from "../template_offering_details_daypass";
import { useBondCollectiveAnalytics } from "./bond-collective_analytics";
import {
  faqs,
  generalInfo,
  partnerConfig,
  testimonials,
} from "./bond-collective_partner_config";
import { Text } from "../text";
import { Spacer } from "../spacer";

const Theme = lazyWithRetry(() => import("./bond-collective_theme"));

export function OfferingBondCollectiveDayPass() {
  useBondCollectiveAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description: (
            <Fragment>
              <Text>
                Redeemable at most Bond Collective locations during operating
                hours, day passes make dropping in easy. For frequent visitors,
                a package of 10 day passes is available as well for $250.
              </Text>
              <Spacer size={10} direction="vertical" />

              <Text>
                What better way to picture yourself in our locations than to try
                it out for a day! Only need space part-time or find yourself in
                the city every so often? Take advantage of the bundled day pass
                package to make the most of your time. As an advantage of being
                a full-time member with Bond Collective, memberships include
                five free day passes to visit other locations or have a guest
                try out the space free of charge.
              </Text>
            </Fragment>
          ),
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
